import React from 'react';
import PropTypes from 'prop-types';
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import RightDrawerDesktopHead from "./components/RightDrawerDesktopHead";
import {Card, CardContent, Grid} from "@mui/material";
import {greyishBlue50} from "../../../../assets/jss/main";

RightDrawerDesktop.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    underTitle: PropTypes.element,
    openMaxWidth: PropTypes.bool,
    withoutHeaderBorder: PropTypes.bool,
    customWidth: PropTypes.string,
    customContentPadding: PropTypes.string,
    hideCloseIcon: PropTypes.bool,
    strictOnClose: PropTypes.bool,
    customHeaderPadding: PropTypes.bool,
    squareCorners: PropTypes.bool,
    blurredBackdrop: PropTypes.bool,
    zIndex: PropTypes.number,
    closeIconTop: PropTypes.number,
    closeIconRight: PropTypes.number
};

function RightDrawerDesktop({
                                title,
                                subtitle,
                                underTitle = null,
                                open = false,
                                onClose = () => {
                                },
                                disablePortal = false,
                                openMaxWidth = false,
                                withoutHeadBorder = false,
                                customWidth = "",
                                customContentPadding = "",
                                hideCloseIcon = false,
                                footer = null,
                                strictOnClose = false,
                                customHeaderPadding = "0 0 0 40px",
                                squareCorners = false,
                                blurredBackdrop = false,
                                zIndex,
                                closeIconTop,
                                closeIconRight,
                                ...props
                            }) {
    return (
        <SwipeableDrawer
            anchor={'right'}
            open={open}
            onClose={strictOnClose ? (event, reason) => {
                if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                    onClose();
                }
            } : onClose}
            onOpen={() => {
            }} // onOpen is not used in this component but required
            sx={{
                ...(zIndex && {zIndex}),
                '.MuiDrawer-paper': {
                    width: openMaxWidth ? '100vw' : customWidth !== '' ? customWidth : "30%",
                    borderTopLeftRadius: squareCorners ? 0 : 24,
                    borderBottomLeftRadius: squareCorners ? 0 : 24,
                    position: 'fixed',
                },
                ...(blurredBackdrop && {
                    '.MuiBackdrop-root': {
                        backgroundColor: 'rgba(23, 23, 23, 0.2)',
                        backdropFilter: 'blur(4px)',
                    }
                })
            }}
            disablePortal={disablePortal}
        >
            <RightDrawerDesktopHead
                title={title}
                subtitle={subtitle}
                onClose={onClose}
                withoutBorder={withoutHeadBorder}
                hideCloseIcon={hideCloseIcon}
                customHeaderPadding={customHeaderPadding}
                closeIconTop={closeIconTop}
                closeIconRight={closeIconRight}
            >
                {underTitle}
            </RightDrawerDesktopHead>
            <Grid
                container
                direction={"column"}
                sx={{flex: 1, overflow: "hidden"}}
                flexWrap={"nowrap"}
            >
                <Grid
                    container
                    direction={"column"}
                    sx={{
                        paddingX: customContentPadding !== "" ? customContentPadding : "40px",
                        marginY: "24px",
                        flex: 1,
                        overflow: "auto"
                    }}
                    flexWrap={"nowrap"}
                >
                    {props.children}
                </Grid>

                {footer && (
                    <Grid
                        container
                        sx={{flexShrink: 0}}
                    >
                        <Card style={{
                            height: 'fit-content',
                            boxShadow: 'none',
                            borderBottom: `1px solid ${greyishBlue50}`,
                            width: '100%',
                            backgroundColor: 'white'
                        }}>
                            <CardContent>
                                {footer}
                            </CardContent>
                        </Card>
                    </Grid>
                )}
            </Grid>
        </SwipeableDrawer>
    );
}

export default RightDrawerDesktop;